import React from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import {useDispatch} from 'react-redux';
import {parse, stringify} from 'query-string';

import {isEmpty} from 'front-onceforall-core/dist/utils/strings';
import {usePrevious} from 'front-onceforall-core/dist/utils/customHooks';

import * as snackbarsActions from '../../../actions/snackbars';
import relationshipService from '../../../services/relationship/RelationshipService';

import {useSubcontractorsStore} from '../SubcontractorsStore';

import SubcontractorsListView from './SubcontractorsListView';

// This is used to force resetting data when unmounting component only if a search has been made (page or query)
let toReset = false;

function SubcontractorsListContainer() {
  const globalDispatch = useDispatch();
  const {state: {subcontractors}, dispatch} = useSubcontractorsStore();
  const location = useLocation();
  const prevLocation = usePrevious(location.pathname + location.search);
  const history = useHistory();
  const [pageNumber, setPageNumber] = React.useState(typeof parse(location.search).page === 'undefined' ? 0 : Number(parse(location.search).page));

  React.useEffect(() => {
    if (prevLocation && prevLocation !== (location.pathname + location.search)) {
      dispatch({type: 'FETCH_SUBCONTRACTORS'});
    }
  });

  React.useEffect(() => {
    toReset = !isEmpty(location.search);
    return () => {
      if (toReset) {
        dispatch({type: 'FETCH_SUBCONTRACTORS'});
      }
    };
  }, []);

  function updateSearchLocation(custom) {
    let search = parse(location.search);
    search = {...search, ...custom};
    search = stringify(search);
    history.push(`${location.pathname}?${search}`);
  }

  function handlePageChange(event, page) {
    toReset = true;
    setPageNumber(page);
    updateSearchLocation({page});
  }

  function handleSearch(query) {
    toReset = true;
    setPageNumber(0);
    updateSearchLocation({query, page: 0});
  }

  function handleDeleteRelationship(relationshipId) {
    relationshipService.deleteRelationship(relationshipId)
      .then(() => {
        dispatch({type: 'FETCH_SUBCONTRACTORS'});
        const organisationName = subcontractors.list.find(subcontractor => subcontractor.relationshipId === relationshipId).fullName;
        globalDispatch(snackbarsActions.addSuccess(<Translate
          value="organisation.delete.success"
          organisationName={organisationName}
        />));
      });
  }

  return (
    <SubcontractorsListView
      onPageChange={handlePageChange}
      onDeleteRelationship={handleDeleteRelationship}
      onSearch={handleSearch}
      pageNumber={pageNumber}
    />
  );
}

export default SubcontractorsListContainer;
